async function resolveYoutubeApi(){
  const context = window;
  return new Promise(resolve => {
    if(context.YT){
      if(!context.YT.loading){
        resolve(context.YT);
      }else{
        context.YT.ready(()=>resolve(context.YT));
      }
    }else{
      const tag = document.createElement('script');
      tag.onload = ()=>context.YT.ready(()=>resolve(context.YT));
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  });
}

export default async function youtube({
  className = 'youtube',
  scaleToFitContainer=true,
  width=1920,
  height=1080,
  yOffset = 200, // hide youtubes controls 🍆
  ...playerSettings
}={}){
  const element = document.createElement('div');
  element.className=className;
  const playerElement = document.createElement('div');
  element.appendChild(playerElement);
  const api = await resolveYoutubeApi();
  const {Player} = api;

  const controller = new Player(playerElement, {
    width,
    height:height + yOffset * 2,
    ...playerSettings,
    events:{
      ...(playerSettings.events || {}),
      onReady(event){
        handleResize();
        playerSettings.events && playerSettings.events.onReady && playerSettings.events.onReady(event);
      }
    }
  });

  function handleResize(){
    const frameElement = element.querySelector('iframe');
    if(!scaleToFitContainer || !frameElement) return;
    const rect = element.getBoundingClientRect();
    const aspectSource = width / height;
    const aspectTarget = rect.width / rect.height;
    if(aspectSource>aspectTarget){
      frameElement.width = aspectSource * rect.height;
      frameElement.height = rect.height + yOffset * 2;
      frameElement.style.top = yOffset * -1 + 'px';
      frameElement.style.left = ((rect.width - frameElement.width) / 2) + "px";
    }else{
      frameElement.width = rect.width;
      frameElement.height = aspectSource * rect.width + yOffset * 2;
      frameElement.style.top = ((rect.height - aspectSource * rect.width) / 2 - yOffset) + "px";
      frameElement.style.left = "0px";
    }
  }

  window.addEventListener('resize',handleResize);

  return {
    element,
    controller,
    destroy(){
      window.removeEventListener('resize',handleResize);
      controller.destroy();
    }
  };
}